import {
    GET_CONSIGNMENTRETURN_DETAILS_SUCCESS,
    GET_CONSIGNMENTRETURN_DETAILS_FAILURE,
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    VALIDATE_PRODUCT_DETAILS_SUCCESS,
} from '../actions';
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { setMyCaseRef } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const validateProductDetailsEndpoint = () =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/validateproductdetails`;

const validateProductDetailsFunc = async (obj) => {
    const response = await axios.post(
        validateProductDetailsEndpoint(),
        obj
    );
    return response ? response.data : {};
};

export function* getConsignmentReturnDetails() {
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    url += '/order/generateMyCaseRef';
    try {
        const result = yield axios.get(url).then((response) => response.data);
        setMyCaseRef(result?.myCaseRef);
        yield put({
            type: GET_CONSIGNMENTRETURN_DETAILS_SUCCESS,
            myCaseRef: result.myCaseRef,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: {}
        });
        yield put({
            type: GET_CONSIGNMENTRETURN_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* validateProductDetailsInReturnSaga(action) {
    try {
        const response = yield validateProductDetailsFunc(action.payload.reqBody);
        
        const validatedProducts = response.products ? response.products : [];

        // if (action.payload.isForReplen) {
        //     const itemTableData = yield select(
        //         (state) => state.reportUsageRootReducer.itemTableData
        //     );
        //     const patientDetails = yield select(
        //         (state) => state.reportUsageRootReducer.patientDetails
        //     );
        //     const validatedItemTableData = getValidatedItemTableData(
        //         itemTableData,
        //         validatedProducts
        //     );
        //     if (
        //         checkIfValidProductsInRecordScreen(
        //             validatedProducts,
        //             validatedItemTableData,
        //             patientDetails
        //         )
        //     ) {
        //         const replenItems =
        //             validatedItemTableData &&
        //             getReplenNonTissueItems(validatedItemTableData);
        //         if (replenItems?.length > 0) {
        //             yield* validateReplenProductsSaga(
        //                 validateReplenProducts(
        //                     replenItems.map((x) => x.cfn).toString()
        //                 )
        //             );
        //         }
        //     }
        // }
        yield put({
            type: VALIDATE_PRODUCT_DETAILS_SUCCESS,
            payload: {
                validItems: validatedProducts,
                productsValidated: true,
            },
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: validateProductDetailsEndpoint(),
            requestPayload: action.payload.reqBody
        });
        yield put({
            type: VALIDATE_PRODUCT_DETAILS_FAILURE,
            payload: {
                validItems: [],
                productsValidated: false,
            },
        });
    }
}
